const registrationStatusMapper: Record<string, Record<any, string>> = {
  registrationStatus: {
    0: 'Not Registered',
    1: 'Pre-Registration Complete',
    2: 'Registered',
  },
};

export default registrationStatusMapper;
